export const CREATE_PUBLIC_DOCUMENT = "CREATE_PUBLIC_DOCUMENT";
export const FETCH_PUBLIC_DOCUMENTS = "FETCH_PUBLIC_DOCUMENTS";
export const FETCH_PUBLIC_DOCUMENT = "FETCH_PUBLIC_DOCUMENT";
export const EDIT_PUBLIC_DOCUMENT = "EDIT_PUBLIC_DOCUMENT";
export const DELETE_PUBLIC_DOCUMENT = "DELETE_PUBLIC_DOCUMENT";
